<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :class="[`${prefix}-icon`, `${prefix}-icon-more2`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_0ec9eaf9c3__a"><rect width="20" height="20" rx="0"/></clipPath></defs><g clip-path="url(#svg_0ec9eaf9c3__a)" :fill="useCurrentColor ? 'currentColor' : '#1D2129'"><circle cx="5" cy="10" r="1.25"/><circle cx="10" cy="10" r="1.25"/><circle cx="15" cy="10" r="1.25"/></g></svg>
</template>
<script>

export default {
  name: 'IconMore2',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
